import React from 'react';
import { layout } from '../../styles/design-tokens';

/**
 * PageContainer Component
 * Standard page layout wrapper with consistent structure
 * 
 * @param {string} width - Container width: 'narrow' | 'content' | 'wide' | 'full'
 * @param {boolean} centerContent - Center content vertically
 * @param {string} className - Additional CSS classes
 * @param {React.ReactNode} children - Page content
 */
const PageContainer = ({ 
  width = 'full',
  centerContent = false,
  className = '',
  children,
}) => {
  // Width classes from design tokens
  const widthClasses = {
    narrow: layout?.narrow,
    content: layout?.content,
    wide: layout?.wide,
    full: 'w-full',
  };
  
  const widthClass = widthClasses?.[width] || widthClasses?.full;
  
  // Center content class
  const centerClass = centerContent ? 'flex items-center justify-center min-h-screen' : '';
  
  return (
    <div className={`${layout?.page} ${centerClass}`}>
      <div className={`${layout?.container} ${layout?.section}`}>
        <div className={`${widthClass} mx-auto ${className}`?.trim()}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageContainer;